// Modal Layer
NP.Modal = (function( $ ) {
	var setCenter = NP.ns( 'Util.setCenter' ),
		stack = NP.ns( 'Util.stack' ),
		instance;

	function Modal( optAll ) {
		this.zIndexTerm = 20;
		this.duration = 200;
		this.isShow = !1;
		this.ctx = [];
		this.optAll = Modal.setup( optAll );

		this._modal = $('<div>', {
			id : 'modalNP',
			style : 'display:none'
		}).css( this.optAll ).appendTo( 'body' ).click(function() {
			instance.hide();
		});

		this._dialog = $('<section />', {
			'class' : 'ly_modal',
			id : 'modalDialog',
			style : 'display:none;position:absolute;'
		}).appendTo( 'body' );

		this.onBeforeShow = $.Callbacks();
		this.onShow = $.Callbacks();
		this.onHide = $.Callbacks();
	}

	Modal.setup = function( optAll ) {
		return $.extend({
			position : 'absolute',
			top : 0, left : 0,
			width : '100%',
			minWidth : 970,
			opacity : 0.5,
			zIndex : 100,
			backgroundColor : '#000'
		}, optAll || {});
	};

	Modal.setCenter = function() {
		setCenter( instance.ctx );
	};

	Modal.onKeydown = function( e ) {
		if ( e.keyCode === 27 ) {
			instance.hide();
		}
	};

	Modal.prototype.show = function( ctx ) {
		if ( !ctx ) return;

		this.onBeforeShow.fire();

		var me = this;
		if ( ctx.txt ) { // dialog modal show
			var btns = $( this.tmpl.button );
			if ( ctx.button && ctx.button.length ) {
				for ( var i = 0, l = ctx.button.length; i < l; i++ ) {
					if ( this.tmpl[ ctx.button[ i ][ 0 ] ] ) {
						btns.append( $( this.tmpl[ ctx.button[ i ][ 0 ] ] ).data( 'click', ( ctx.button[ i ][ 1 ] || function() { me.hide(); } ) ).click(function() {
							$( this ).data( 'click' ).call( me );
						}) );
					}
				}
			} else { // button 이 없을 경우 confirm 버튼 노출
				btns.append( $( this.tmpl['confirm'] ).click(function() {
					me.hide();
				}) );
			}

			btns.find( 'a' ).eq( 0 ).addClass( 'emphasis' );

			ctx = this._dialog.html('').append( $( this.tmpl.dialogLayout( ( NP.Util.getTemplate( ctx.txt ) )( ctx.data ) ) ).append( btns ) );
		} else {
			ctx.css('position', 'absolute');
		}

		if ( !this.ctx.length ) {
			this.savedZIndex = this.optAll.zIndex + this.zIndexTerm;
		} else {
			this._modal.css( 'zIndex', this.savedZIndex + this.zIndexTerm / 2 );
			this.savedZIndex = this.savedZIndex + this.zIndexTerm;
		}
		this.showModal();

		var isRep = stack( this.ctx, ctx.css( 'zIndex', this.savedZIndex )[0] );

		setCenter( this.ctx );
		ctx.fadeIn( this.duration );

		!isRep && ctx.find('.js_close').click(function() {
			instance.hide();
		});

		!this.isShow && NP.win.bind({
			resize : Modal.setCenter,
			keydown : Modal.onKeydown
		});

		this.onShow.fire();

		this.isShow = !0;
	};

	Modal.prototype.hide = function() {
		if ( this.ctx.length <= 1 ) {
			this.clear();
		} else {
			this.ctx.pop().hide().css( 'zIndex', '' ).find('.js_close').unbind();
			this._modal.css( 'zIndex', this.savedZIndex = this.savedZIndex - ( this.zIndexTerm * 1.5 ) );
		}

		this.onHide.fire();
	};

	Modal.prototype.clear = function() {
		$( this.ctx ).each(function() {
			instance.ctx.pop().hide().css( 'zIndex', '' ).find('.js_close').unbind();
		});
		this._modal.hide().css( 'zIndex', this.optAll.zIndex );

		NP.win.unbind({
			resize : Modal.setCenter,
			keydown : Modal.onKeydown
		});

		this.isShow = !1;
	};

	Modal.prototype.showModal = function() {
		this._modal.css({
			height : $( document ).height()
		}).fadeIn( this.duration );
	};

	Modal.prototype.tmpl = {
		dialogLayout : function( ctx ) {
			return '<div class="wrap_dialog"><a class="close js_close">닫기</a><p class="question">' + ctx + '</p></div>';
		},
		button : '<div class="wrap_button"></div>',
		use : '<a class="btn_rect"><span>사용하기</span></a>',
		confirm : '<a class="btn_rect"><span>확인</span></a>',
		hide : '<a class="btn_rect"><span>숨기기</span></a>',
		blocked : '<a class="btn_rect"><span>차단하기</span></a>',
		cancel : '<a class="btn_rect"><span>취소</span></a>',
		'delete' : '<a class="btn_rect"><span>삭제</span></a>',
		yes : '<a class="btn_rect"><span>예</span></a>',
		no : '<a class="btn_rect"><span>아니오</span></a>'
	};

	return {
		getInstance : function( optAll ) {
			if ( !instance ) {
				instance = new Modal( optAll );
				instance.constructor = null;
			}
			return instance;
		}
	};
}( jQuery ));

var modal = NP.Modal.getInstance();
modal.onBeforeShow.add(function() {
	mProfile.isOn && mProfile.hide();
	modal._modal.css( 'zIndex', modal.optAll.zIndex = modal.savedZIndex = NP.zIndex.get() );
	NP.zIndex['+']();
});
modal.onHide.add( NP.zIndex['-'] );